<template>
  <div class="whitespace-nowrap">
    <div class="flex items-center overflow-y-scroll no-scrollbar px-[4vw] mx-[-4vw]">
      <div class="button-group text-sm" v-auto-animate>
        <button @click="useUpdateQuery({ tagIds: undefined })" :class="{ 'active': !$route.query?.tagIds }">Stockholm</button>
        <button v-for="tag in app.tags.filter(tag => activeCityPartIds.includes(tag.id))" :key="tag.id" :class="{ 'active': $route.query?.tagIds?.split(',')?.includes(tag.id.toString()) && $route.query?.tagIds !== activeCityPartIds.join(',') }" @click="useUpdateQuery({ tagIds: tag.id })">
          {{ tag.label }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
const app = useAppStore()

const activeCityPartIds = [
  133,
  134,
  135,
  // 136,
  // 137,
]
</script>